/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationWithRelations } from '../../models/location-with-relations';

export interface GetInventoryLocations$Params {
  id: string;
  nested?: boolean;
}

export function getInventoryLocations(http: HttpClient, rootUrl: string, params: GetInventoryLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LocationWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getInventoryLocations.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('nested', params.nested, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LocationWithRelations>>;
    })
  );
}

getInventoryLocations.PATH = '/admin/inventories/{id}/locations';
